/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import NavigationBar from "../common/NavigationBar";
import Footer from "../common/Footer";
import ContactSection from "../common/ContactAs";


const PrivacyPolicy = () => {
  const navigate = useNavigate();
  const homeRef = useRef(null);
  const aboutRef = useRef(null);
  const servicesRef = useRef(null);
  const offersRef = useRef(null);
  const contactRef = useRef(null);

  const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleTermsConditions = () => {
    navigate("/terms-conditions");
  };

  return (
    <div className="terms-container">
      <NavigationBar
        homeRef={homeRef}
        aboutRef={aboutRef}
        servicesRef={servicesRef}
        offersRef={offersRef}
        contactRef={contactRef}
      />

      <section id="terms-conditions" className="terms-section">
        <h1>Privacy Policy</h1>
        <div className="policy-header-content">
          <h4 className="highlight-color highlight-rate">Privacy Summary</h4>
          <div className="policy-section-description">
            <p className="privacy-policy-para">
              <span className="privacy-policy-icon">●</span>
              At RightLender.in, your privacy is our priority. Here’s how we
              protect and use your information:
            </p>
            <ul className="policy-bullet-list">
              <li>
                What we collect – Only basic details you share (name, contact,
                income, loan need).
              </li>
              <li>
                No credit pull – We never check your
                CIBIL/ Equifax/ Experian/ Highmark reports. Only Banks/NBFCs do
                when you apply.
              </li>
              <li>
                Why we collect – To match you with the best Banks/NBFCs and send
                loan updates.
              </li>
              <li>
                Who we share with – Only trusted partners (Banks/NBFCs/service
                providers). Never sold to anyone.
              </li>
              <li>
                Your control – You can access, correct, or delete your
                information anytime.
              </li>
              <li>
                Secure – Your data is stored with encryption and strict access
                controls.
              </li>
              <li>
                Legal use only – Shared only if required by law/regulators.
              </li>
            </ul>
            <p className="privacy-policy-para">
              <span className="privacy-policy-icon">●</span>
              For full details, please read our{" "}
              <span
                className="nav-privacy-policy"
                onClick={handleTermsConditions}
              >
                Terms & Conditions
              </span>
              .
            </p>
            <p className="privacy-policy-para">
              <span className="privacy-policy-icon">●</span>
              Effective Date: <b>[Last Updated 1.8.2025]</b>
            </p>
            <p className="privacy-policy-para">
              <span className="privacy-policy-icon">●</span>
              RightLender.in (Perukkal 100 Consultancy Private Limited CIN -
              U66190TZ2024PTC031218) is committed to protecting the privacy of
              its users. This Privacy Policy explains how we collect, use,
              share, and protect your personal information when you use our
              Website{" "}
              <b>
                (<span className="highlight-color">www.rightlender.in</span>)
              </b>{" "}
              and our <b>mobile applications (Android/iOS)</b> (together
              referred to as the “Platform”).
            </p>
          </div>
        </div>

        <div className="policy-header-content">
          <h4 className="highlight-color highlight-rate">
            Information We Collect
          </h4>
          <div className="policy-section-description">
            <p className="privacy-policy-para">
              <span className="privacy-policy-icon">●</span>
              When you access or use our Services, we may collect the following
              categories of information:
            </p>
          </div>
          <div className="policy-section-subcontent">
            <strong className="privacy-policy-questions">
              1. Information You Provide Directly
            </strong>
            <ul className="policy-bullet-list privacy-policy-para">
              <li>Name, Gender, Date of Birth</li>
              <li>Contact details (email address, phone number)</li>
              <li>Permanent and Current Address</li>
              <li>PAN and identity details</li>
              <li>Employment and Income details</li>
              <li>Loan requirements and preferences</li>
            </ul>
          </div>
          <div className="policy-section-subcontent">
            <strong className="privacy-policy-questions">
              2. Information Collected Automatically
            </strong>
            <ul className="policy-bullet-list privacy-policy-para">
              <li>Device information (model, operating system, app version)</li>
              <li>
                Log data (IP address, browser type, access time, pages viewed)
              </li>
              <li>
                Usage data (how you interact with the Website or Mobile App)
              </li>
            </ul>
          </div>
          <div className="policy-section-subcontent">
            <strong className="privacy-policy-questions">
              3. Third-Party Information
            </strong>
            <ul className="policy-bullet-list privacy-policy-para">
              <li>
                <b>Credit Reports & Scores</b>: Right Lender does not directly
                fetch or access your credit report/score from any Credit Bureau
                (CIBIL, Equifax, Experian, CRIF Highmark).
              </li>
              <li>
                Credit-related information is obtained only by the{" "}
                <b>Bank/NBFC</b> with whom you apply for a product.
              </li>
            </ul>
          </div>
        </div>

        <div className="policy-header-content">
          <h4 className="highlight-color highlight-rate">
            How We Use Your Information
          </h4>
          <div className="policy-section-description">
            <p className="privacy-policy-para">
              <span className="privacy-policy-icon">●</span>
              We use the information collected for the following purposes:
            </p>
            <ul className="policy-bullet-list">
              <li>
                To register you on the Platform and maintain your account.
              </li>
              <li>
                To connect you with Banks, NBFCs, and lending partners best
                suited to your profile.
              </li>
              <li>
                To send you application updates and alerts (via SMS, WhatsApp,
                email, or app notifications).
              </li>
              <li>To respond to your queries and provide customer support.</li>
              <li>To improve our Platform, services, and user experience.</li>
              <li>
                To comply with legal, regulatory, and contractual obligations.
              </li>
            </ul>
          </div>
        </div>

        <div className="policy-header-content">
          <h4 className="highlight-color highlight-rate">
            Sharing of Information
          </h4>
          <div className="policy-section-description">
            <p className="privacy-policy-para">
              <span className="privacy-policy-icon">●</span>
              We may share your information only in the following cases:
            </p>
            <ul className="policy-bullet-list">
              <li>
                <b>With Banks/NBFCs/Lending Partners</b> – to process your loan
                application.
              </li>
              <li>
                <b>With Service Providers</b> – who help us deliver services (IT
                support, SMS/email providers, cloud hosting, etc.).
              </li>
              <li>
                <b>For Legal/Regulatory Requirements</b> – when required by law,
                court order, or government authority.
              </li>
              <li>
                <b>In Business Transfers</b> – if Right Lender is involved in a
                merger, acquisition, or sale of assets, user information may be
                transferred.
              </li>
            </ul>
            <p className="privacy-policy-para">
              <span className="privacy-policy-icon">●</span>
              We never sell your personal information to third parties.
            </p>
          </div>
        </div>

        <div className="policy-header-content">
          <h4 className="highlight-color highlight-rate">Data Security</h4>
          <div className="policy-section-description">
            <ul className="policy-bullet-list">
              <li>
                We use{" "}
                <b>
                  encryption, secure servers, firewalls, and access controls
                </b>{" "}
                to safeguard your information.
              </li>
              <li>
                While we take all reasonable precautions, no method of data
                transmission or storage can be guaranteed as 100% secure. You
                agree to use our services at your own risk.
              </li>
            </ul>
          </div>
        </div>

        <div className="policy-header-content">
          <h4 className="highlight-color highlight-rate">Data Retention</h4>
          <div className="policy-section-description">
            <ul className="policy-bullet-list">
              <li>
                We retain your personal information only as long as necessary
                for the purposes outlined in this Privacy Policy, or as required
                by applicable law.
              </li>
              <li>
                Since Right Lender does not pull or store Credit Bureau reports,
                we do not retain your credit scores.
              </li>
            </ul>
          </div>
        </div>

        <div className="policy-header-content">
          <h4 className="highlight-color highlight-rate">Your Rights</h4>
          <div className="policy-section-description">
            <p className="privacy-policy-para">
              <span className="privacy-policy-icon">●</span>
              You have the right to:
            </p>
            <ul className="policy-bullet-list">
              <li>Access the personal information we hold about you.</li>
              <li>
                Request correction or updating of inaccurate or incomplete data.
              </li>
              <li>
                Withdraw your consent to data usage (this may affect your
                ability to use our Services).
              </li>
              <li>
                Request deletion of your personal information, subject to legal
                and regulatory requirements.
              </li>
            </ul>
            <p className="privacy-policy-para">
              <span className="privacy-policy-icon">●</span>
              To exercise these rights, you may contact us at{" "}
              <b>[Insert Contact Email/Support Details]</b>.
            </p>
          </div>
        </div>

        <div className="policy-header-content">
          <h4 className="highlight-color highlight-rate">Cookies & Tracking</h4>
          <div className="policy-section-description">
            <ul className="policy-bullet-list">
              <li>
                Our Website and Mobile Apps may use cookies or similar
                technologies to improve functionality and user experience.
              </li>
              <li>
                You may disable cookies in your browser/app settings, but some
                features may not work properly.
              </li>
            </ul>
          </div>
        </div>

        <div className="policy-header-content">
          <h4 className="highlight-color highlight-rate">Third-Party Links</h4>
          <div className="policy-section-description">
            <p className="privacy-policy-para">
              <span className="privacy-policy-icon">●</span>
              Our Platform may contain links to third-party websites/apps. We
              are not responsible for the privacy practices or content of such
              third parties.
            </p>
          </div>
        </div>

        <div className="policy-header-content">
          <h4 className="highlight-color highlight-rate">Children’s Privacy</h4>
          <div className="policy-section-description">
            <p className="privacy-policy-para">
              <span className="privacy-policy-icon">●</span>
              Our Services are intended for individuals{" "}
              <b>18 years of age or older</b>. We do not knowingly collect
              personal data from minors. If we discover that a minor has
              provided us information, we will delete it immediately.
            </p>
          </div>
        </div>

        <div className="policy-header-content">
          <h4 className="highlight-color highlight-rate">
            Updates to this Privacy Policy
          </h4>
          <div className="policy-section-description">
            <p className="privacy-policy-para">
              <span className="privacy-policy-icon">●</span>
              We may update this Privacy Policy from time to time. Any changes
              will be posted on this page with a revised <b>“Effective Date”</b>
              . Continued use of our Services after changes indicates your
              acceptance of the updated policy.
            </p>
          </div>
        </div>
      </section>
      {/* Contact Section */}
      <section ref={contactRef}>
        <ContactSection
          scrollToSection={scrollToSection}
          homeRef={homeRef}
          aboutRef={aboutRef}
          servicesRef={servicesRef}
          contactRef={contactRef}
        />
      </section>
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
